<template>
  <div class="text-sm text-gray-800 space-y-1">
    <div v-if="configSection.hasAssociatedGroup" class="flex gap-x-2">
      <span class="font-medium text-gray-600">Grupo de actividades asociado:</span>
      <span class="text-gray-900 font-semibold">{{ getGroupName(configSection.groupId) || '-' }}</span>
    </div>

    <div class="flex gap-x-2">
      <span class="font-medium text-gray-600">Cantidad de imágenes adicionales:</span>
      <span class="text-gray-900 font-semibold">{{ configSection.numberOfExtraImages }}</span>
    </div>

    <div class="flex gap-x-2">
      <span class="font-medium text-gray-600">¿Sección deshabilitable por el usuario?</span>
      <span class="text-gray-900 font-semibold">{{ configSection.canDisableSection ? 'Sí' : 'No' }}</span>
    </div>

    <div v-if="hasDocumentType(configSection)" class="flex gap-x-2">
      <span class="font-medium text-gray-600">Imagen principal desde:</span>
      <span class="text-gray-900 font-semibold">{{ $t(configSection.documentType) || '-' }}</span>
    </div>

    <div v-if="hasDocumentType(configSection)" class="flex gap-x-2">
      <span class="font-medium text-gray-600">¿Usuario puede definir leyendas?</span>
      <span class="text-gray-900 font-semibold">{{ configSection.userCanDefineLegend ? 'Sí' : 'No' }}</span>
    </div>

    <div v-if="configSection.code === 'GANTT'" class="flex gap-x-2">
      <span class="font-medium text-gray-600">{{ $t('gantt_page_orientation') }}:</span>
      <span class="text-gray-900 font-semibold">{{ configSection.ganttLandscape ? $t('landscape') : $t('portrait') }}</span>
    </div>

    <div v-if="configSection.code === 'GANTT'" class="flex gap-x-2">
      <span class="font-medium text-gray-600">{{ $t('gantt_allow_user_change_orientation') }}:</span>
      <span class="text-gray-900 font-semibold">{{ configSection.ganttUserCanChangeOrientation ? 'Sí' : 'No' }}</span>
    </div>

    <div class="flex gap-x-2">
      <span class="font-medium text-gray-600">Visible:</span>
      <span class="text-gray-900 font-semibold">{{ configSection.visible ? 'Sí' : 'No' }}</span>
    </div>
  </div>
</template>

<script>
import { getGroupNameById } from '../services/helpers.service';

export default {
  name: "SectionConfigView",
  props: {
    configSection: {
      type: Object,
      required: true
    },
    activityGroups: {
      type: Array,
      default: () => []
    }
  },

  methods: {
    getGroupName(id) {
      if (!id) return '-';

      return getGroupNameById(id, this.activityGroups);
    },

    hasDocumentType(item) {
      return item && typeof item.documentType !== 'undefined';
    },
  }
}
</script>